import React from "react";
import Menu from "./Menu";
import MenuItem from "./MenuItem";
import MenuButton from "./MenuButton";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleMenuClick() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  handleLinkClick(index) {
    if (index == 0) this.props.history.push("/");
    if (index == 1) this.props.history.push("/starwards");
    this.setState({ menuOpen: false });
  }

  render() {
    const styles = {
      container: {
        position: "sticky",
        top: 0,
        left: 0,
        zIndex: "99",
        opacity: 0.9,
        display: "flex",
        alignItems: "center",
        background: "black",
        width: "100%",
        color: "white",
        fontFamily: "Lobster",
        fontSize: "2rem",
      },
      logo: {
        margin: "0 auto",
      },
      body: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
        filter: this.state.menuOpen ? "blur(2px)" : null,
        transition: "filter 0.5s ease",
      },
    };
    const menu = ["Home", "Starwards"];
    const menuItems = menu.map((val, index) => {
      return (
        <MenuItem
          key={index}
          delay={`${index * 0.1}s`}
          onClick={() => {
            this.handleLinkClick(index);
          }}
        >
          {val}
        </MenuItem>
      );
    });

    return (
      <div>
        <div style={styles.container}>
          <MenuButton
            open={this.state.menuOpen}
            onClick={() => this.handleMenuClick()}
            color="white"
          />
          <div style={styles.logo}>Pixelinium</div>
        </div>
        <Menu open={this.state.menuOpen}>{menuItems}</Menu>
      </div>
    );
  }
}

Header.propTypes = {
  history: PropTypes.any,
};

export default withRouter(Header);
